import React from 'react'
import { useForm } from 'react-hook-form'
import classNames from 'classnames'
import { useUpdateFundingRequest } from '@/api/kubik/credit'
import { Button } from '@/components/ui'
import { CommunicationMethodSelectorItem } from './components/CommunicationMethodSelectorItem'
import { ECommunicationMethod } from './constants'
import { messages } from './messages'
import type { ICommunicationMethodSelectorProps } from './types'
import './styles.scss'

export const CommunicationMethodSelector: React.FC<ICommunicationMethodSelectorProps> = props => {
  const {
    className,
    title = messages.title,
    titleClassName,
    cardClassName,
    buttonClassName,
    fundingRequestId,
    containerClassName,
    onSuccessUpdateFundingRequest,
    onErrorUpdateFundingRequest,
  } = props

  const { control, getValues, watch } = useForm({
    defaultValues: {
      communicationMethod: ECommunicationMethod.PHONE,
    },
  })

  const communicationMethodField = watch('communicationMethod')

  const { mutateAsync: updateFundingRequest, isLoading } = useUpdateFundingRequest({
    mutation: { onSuccess: onSuccessUpdateFundingRequest, onError: onErrorUpdateFundingRequest },
  })

  const onSelectCommunicationMethod = async () => {
    await updateFundingRequest({ fundingRequestId, communicationMethod: getValues('communicationMethod') })
  }

  return (
    <div className={classNames(className, 'communicationMethodSelector')}>
      <h3 className={classNames(titleClassName, 'communicationMethodSelector__title')}>{title}</h3>

      <div className={classNames(containerClassName, 'communicationMethodSelector__container')}>
        <CommunicationMethodSelectorItem
          className={cardClassName}
          control={control}
          image="financingOffer/agent/connections/phone.png"
          value={ECommunicationMethod.PHONE}
          isSelected={communicationMethodField === ECommunicationMethod.PHONE}
          label={messages.fields.communicationMethod.phone}
        />
        <CommunicationMethodSelectorItem
          className={cardClassName}
          control={control}
          image="financingOffer/agent/connections/email.png"
          value={ECommunicationMethod.EMAIL}
          isSelected={communicationMethodField === ECommunicationMethod.EMAIL}
          label={messages.fields.communicationMethod.email}
        />
      </div>

      <div className="communicationMethodSelector__actions">
        <Button
          className={buttonClassName}
          type="submit"
          modifiers={['green']}
          loaderProps={{ isVisible: isLoading }}
          onClick={onSelectCommunicationMethod}
        >
          {messages.actions.select}
        </Button>
      </div>
    </div>
  )
}
